import React, { useState, useEffect } from 'react';
import styles from './PerfisAcesso.module.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import {
  User, ChevronLeft, ChevronRight, MoreVertical, Trash2, Shield,
  Plus, Edit, Key, Eye
} from 'lucide-react';
import { API_URL } from '../../api';
import { useNavigate } from 'react-router-dom';

// Dados mockados para demonstração
const mockPerfis = [
  {
    id: 1,
    tipo: 'administrador',
    nome: 'Administrador',
    descricao: 'Acesso completo a todas as funcionalidades do sistema, incluindo configurações avançadas e gerenciamento de usuários.',
    permissoes: ['Edição de pedidos', 'Exclusão de clientes', 'Aprovação de cadastros', 'Configurações do sistema', 'Gerenciamento de usuários'],
    licenca: 'total'
  },
  {
    id: 2,
    tipo: 'vendedor',
    nome: 'Vendedor',
    descricao: 'Acesso às funcionalidades de vendas, cadastro de clientes e visualização de pedidos.',
    permissoes: ['Cadastro de clientes', 'Criação de pedidos', 'Visualização de relatórios'],
    licenca: 'total'
  },
  {
    id: 3,
    tipo: 'gerente',
    nome: 'Gerente Comercial',
    descricao: 'Acesso às funcionalidades de gestão comercial, aprovação de pedidos e visualização de relatórios gerenciais.',
    permissoes: ['Aprovação de pedidos', 'Visualização de relatórios gerenciais', 'Edição de preços', 'Gestão de equipe'],
    licenca: 'total'
  },
  {
    id: 4,
    tipo: 'visualizacao_logistica',
    nome: 'Visualizador Lojística',
    descricao: 'Acesso somente para visualização de dados, sem permissão para edição ou criação de registros.',
    permissoes: ['Visualização de pedidos', 'Visualização de clientes', 'Visualização de relatórios básicos'],
    licenca: 'visualizacao'
  },
  {
    id: 5,
    tipo: 'visualizacao_financeiro',
    nome: 'Visualizador Financeiro',
    descricao: 'Acesso somente para visualização de dados financeiros, sem permissão para edição ou criação de registros.',
    permissoes: ['Visualização de relatórios financeiros', 'Visualização de finanças'],
    licenca: 'visualizacao'
  }
];

function ListaPerfisAcesso() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [perfis, setPerfis] = useState([]);
  const [totalItens, setTotalItens] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [menuAcoesAberto, setMenuAcoesAberto] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchPerfis() {
      setCarregando(true);
      try {
        // Em um ambiente real, isso seria uma chamada à API
        // const response = await fetch(`${API_URL}/perfis-acesso?page=${paginaAtual}`);
        // const data = await response.json();
        
        // Usando dados mockados para demonstração
        setTimeout(() => {
          setPerfis(mockPerfis);
          setTotalItens(mockPerfis.length);
          setTotalPaginas(1);
          setCarregando(false);
        }, 500);
      } catch (e) {
        setPerfis([]);
        setTotalItens(0);
        setTotalPaginas(1);
        setCarregando(false);
      }
    }
    fetchPerfis(); 
  }, [paginaAtual]);

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina);
    }
  };

  // Gerar array de páginas para exibir
  const gerarPaginas = () => {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    if (totalPaginas <= maxPaginasVisiveis) {
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(i);
      }
    } else {
      if (paginaAtual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      } else if (paginaAtual >= totalPaginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = totalPaginas - 3; i <= totalPaginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = paginaAtual - 1; i <= paginaAtual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      }
    }
    return paginas;
  };

  const handleAbrirMenuAcoes = (perfilId) => {
    setMenuAcoesAberto(perfilId);
  };
  
  const handleFecharMenuAcoes = () => {
    setMenuAcoesAberto(null);
  };

  // Função para redirecionar para a página de editar
  const handleEditar = (perfil) => {
    // navigate(`/perfil-acesso/editar/${perfil.id}`);
    alert(`Editar perfil: ${perfil.nome}`);
    setMenuAcoesAberto(null);
  };

  // Função para obter a classe CSS do tipo de perfil
  const getTipoClass = (tipo) => {
    switch (tipo) {
      case 'administrador':
        return styles.tipoAdmin;
      case 'vendedor':
        return styles.tipoVendedor;
      case 'gerente':
        return styles.tipoGerente;
      case 'visualizacao':
        return styles.tipoVisualizacao;
      default:
        return '';
    }
  };

  // Função para obter a classe CSS do tipo de licença
  const getLicencaClass = (licenca) => {
    switch (licenca) {
      case 'total':
        return styles.licencaTotal;
      case 'visualizacao':
        return styles.licencaVisualizacao;
      default:
        return '';
    }
  };

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar
          setMenuAberto={setMenuAberto}
          titulo="Perfis de Acesso"
          botao={<button className="btn-novo-perfil">+ Novo Perfil</button>}
        />
        <div className="conteudo-dashboard perfis-acesso-listagem">
          <div className="card-page-main">
            <div className="card-page-main-header">
              <div className="card-page-main-header-title">
                <h2>Perfis de Acesso</h2>
              </div>
              <button className="btn btn-primary">
                <Plus size={18} style={{ marginRight: 6 }} /> Novo Perfil
              </button>
            </div>
            
            <div className="cards-list">
              {carregando ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Carregando perfis de acesso...</div>
              ) : perfis.length === 0 ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Nenhum perfil de acesso encontrado.</div>
              ) : (
                perfis.map(perfil => (
                  <div className="card-list" key={perfil.id} style={{
                    gap: 0
                  }}>
                    <div className="card-list-header">
                      <div>
                        <span className={`card-titulo ${styles.listCardTitulo}`}>{perfil.nome}</span>
                      </div>
                      
                      <div className="card-list-acoes">
                        <button
                          className="card-list-acoes-btn"
                          onClick={() => menuAcoesAberto === perfil.id ? handleFecharMenuAcoes() : handleAbrirMenuAcoes(perfil.id)}
                          tabIndex={0}
                          aria-label="Ações do perfil"
                        >
                          <MoreVertical size={20} />
                        </button>
                        {menuAcoesAberto === perfil.id && (
                          <div className="card-list-menu-popover" onMouseLeave={handleFecharMenuAcoes}>
                            <button className="card-list-menu-item" onClick={() => handleEditar(perfil)}> 
                              <Edit size={16} style={{ marginRight: 8 }} /> Editar
                            </button>
                            <button className="card-list-menu-item comunicado-menu-excluir" onClick={() => { handleFecharMenuAcoes(); /* ação excluir */ }}>
                              <Trash2 size={16} style={{ marginRight: 8 }} /> Excluir
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="card-list-body">
                      <div className={`${styles.listCardDescricao}`}>
                        {perfil.descricao}
                      </div>

                      <div className={`${styles.perfilPermissoes}`}>
                        {perfil.permissoes.map((permissao, index) => (
                          <span key={index} className={`${styles.perfilPermissao}`}>
                            {permissao}
                          </span>
                        ))}
                      </div>

                      <div className={`${styles.listCardDocData}`}>
                        <div className={`${styles.tipoLicencaProtheus}`}>
                          {/* <Key size={14} style={{ marginRight: 4 }} /> */}
                          Protheus: <span className={`${styles.keyLicencaProtheus}`}>{perfil.tipo}</span>
                        </div>
                        <div className={`${styles.perfilLicenca} ${getLicencaClass(perfil.licenca)}`}>
                          Licença: {perfil.licenca === 'total' ? 'Total' : 'Visualização'}
                        </div>
                        
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            
            {/* Componente de Paginação */}
            {totalPaginas > 1 && (
              <div className="paginacao-container">
                <div className="paginacao-info">
                  <span>
                    Mostrando {(paginaAtual - 1) * 10 + 1} a {Math.min(paginaAtual * 10, totalItens)} de {totalItens} perfis
                  </span>
                </div>
                <div className="paginacao-controles">
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual - 1)}
                    disabled={paginaAtual === 1}
                  >
                    <ChevronLeft size={16} />
                    Anterior
                  </button>
                  
                  <div className="paginacao-numeros">
                    {gerarPaginas().map((pagina, index) => (
                      <button
                        key={index}
                        className={`paginacao-numero ${pagina === paginaAtual ? 'ativo' : ''} ${pagina === '...' ? 'separador' : ''}`}
                        onClick={() => typeof pagina === 'number' && mudarPagina(pagina)}
                        disabled={pagina === '...'}
                      >
                        {pagina}
                      </button>
                    ))}
                  </div>
                  
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual + 1)}
                    disabled={paginaAtual === totalPaginas}
                  >
                    Próxima
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListaPerfisAcesso;